module.exports = __webpack_public_path__ + "static/media/jacob.3cb8999e.jpg";